import * as Sentry from '@sentry/react';

import { dpConfig, sentryConfig } from 'src/config';

type SentryRouter = Parameters<
  typeof Sentry.tanstackRouterBrowserTracingIntegration
>[0];

export function trace(router: SentryRouter) {
  if (!sentryConfig.dsn) {
    return;
  }

  Sentry.init({
    dsn: sentryConfig.dsn,
    environment: dpConfig.env,
    integrations: [
      Sentry.tanstackRouterBrowserTracingIntegration(router),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: sentryConfig.tracesSampleRate,
    tracePropagationTargets: ['localhost', dpConfig.http.api].filter(
      (target): target is string => Boolean(target),
    ),
    replaysSessionSampleRate: sentryConfig.replaysSessionSampleRate,
    replaysOnErrorSampleRate: sentryConfig.replaysOnErrorSampleRate,
  });
}
